import React from "react";

import Row from "../../../common/grid/Row";
import Col from "../../../common/grid/Col";
// import Button from '../../../common/button/Button'
import ProfileInfo from "./ProfileInfo";
import Permisions from "./Permisions";
import ProfileImage from "./ProfileImage";
import "./Profile.css";

const Profile = () => {
	return (
		<Row _gap-16 profile _no-grow-first>
			{/* <Col _bottom-16 _no-grow profile-thumbnail>
                 <div className="thumbnail">
                 <img src="/ph-thumbnail.jpg" alt="user profileww picture"/>
                 </div>
                 <Button className="btn-blue btn-square">CHANGE THUMBNAIL</Button>
                 </Col> */}
			<ProfileImage />
			<Col _bottom-32>
				<ProfileInfo />
				<Permisions />
			</Col>
		</Row>
	);
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/main/profile/Profile.js